import React from "react"
import { View } from "react-native"
import { Body } from "@/components/standard/BFText"
import { Vertical } from "@/components/standard/BFLayout"

interface CompMapViewProps {
  comps: any[]
  analysis?: any
}

export function CompMapView({ comps, analysis }: CompMapViewProps) {
  // For now, this is a placeholder for the map view
  // You can integrate with react-native-maps or another mapping library here

  return (
    <View className="flex-1 bg-secondary/20 border border-border rounded-lg">
      <Vertical className="flex-1 justify-center items-center p-6">
        <Body className="text-center text-muted-foreground">
          Map View Coming Soon
        </Body>
        <Body className="text-center text-muted-foreground mt-2 text-sm">
          {comps.length} properties would be displayed on the map
        </Body>
        {analysis?.property?.fullAddress && (
          <Body className="text-center text-muted-foreground mt-4 text-xs">
            Subject Property: {analysis.property.fullAddress}
          </Body>
        )}
      </Vertical>
    </View>
  )
}
